<template>
    <div id="consultation" class="section">
        <h1 class="header">{{ $t("consultation.header") }}<span class="header-dot">.</span></h1>
        <div class="header-separator"></div>
        <p class="explanation">
            {{ $t("consultation.explanation-1.line-1") }}
            <br>
            {{ $t("consultation.explanation-1.line-2") }}
            <br>
            {{ $t("consultation.explanation-1.line-3") }}
        </p>
        <div class="content">
            <div class="interactive-display">

                <div class="item-list">
                    <div class="item left-side">
                        <p class="text">{{ $t("consultation.list-1.item-1") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/person.png" alt="">
                        </div>
                    </div>
                    <div class="item left-side">
                        <p class="text">{{ $t("consultation.list-1.item-2") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/magnifing-glass.png" alt="">
                        </div>
                    </div>
                    <div class="item left-side">
                        <p class="text">{{ $t("consultation.list-1.item-3") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/graph.png" alt="">
                        </div>
                    </div>
                </div>

                <div class="display">
                    <img class="logo" src="../../../assets/images/logos/company-logo.png" alt="">
                </div>

                <div class="item-list">
                    <div class="item right-side">
                        <p class="text">{{ $t("consultation.list-2.item-1") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/headset.png" alt="">
                        </div>
                    </div>
                    <div class="item right-side">
                        <p class="text">{{ $t("consultation.list-2.item-2") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/wrench.png" alt="">
                        </div>
                    </div>
                    <div class="item right-side">
                        <p class="text">{{ $t("consultation.list-2.item-3") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/consultation/scholar-cap.png" alt="">
                        </div>
                    </div>
                </div>

            </div>
            <!-- <p></p> -->
        </div>
        <p class="explanation">
            {{ $t("consultation.explanation-2.line-1") }}
            <br>
            {{ $t("consultation.explanation-2.line-2") }}
        </p>
    </div>
</template>